module.exports = __webpack_public_path__ + "img/Leading-a-Class.1c5d4bc4.png";